(function ($) {

	'use strict';
	
	/**
	 * checks if required inputs are filled
	 * NOTE: The check only works if the label comes immediately before the input
	 * 
	 * @param {jQueryObject} $form
	 * @returns {Boolean}
	 */
	$.checkRequiredFormFields = function($form) {
		if (!$form || $form.length === 0) {
			$form = $('body');
		}

		// select required fields
		var $requiredFields = $form.find('.required').parent().next();

		// focus required element if it is empty
	//							var $firstEmptyInput =  $('[id^="p_VORNAME_"], [id^="p_FAMNAME_"], [id^="p_STATUS_"]').filter(function() {
		var $firstEmptyInput = $requiredFields.filter(function () {

			console.log($(this).attr('id') + ':', this.value, $(this).val(), this);

			if (!this.value) {
				// insert span
				var $label = $(this).siblings('label');
				var $labelError = $label.find('.formerr');

				if ($labelError.length === 0) {
					$label.prepend('<span class="formerr">' + $.i81n.text('VAL_NEEDED') + '</span>');
				} else {
					$labelError.text($.i81n.text('VAL_NEEDED'));
				}

				return true;
			}

			return false;
		}).first();

		console.log($firstEmptyInput);

		if ($firstEmptyInput.length > 0) {
			$firstEmptyInput.focus();

			return false;
		}

		return true;
	};
}(jQuery));